export const getCommentsUnviewedNotificationIds = (comments) => {
    return comments.flatMap(c => (c.notification && !c.notification.viewedAt ? c.notification.id : []));
};
//# sourceMappingURL=utils.js.map